import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import fr from './locales/fr';
import nl from './locales/nl';
import { detectLanguage, storeLanguage, tenantFallbackLanguage, tenantLanguages } from './language';
import type { Language } from './language';

export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './language';
export { tenantLanguages, isSwitcherEnabled } from './language';
export type { Language } from './language';

i18n.use(initReactI18next).init({
  lng: detectLanguage(),
  // Per tenant, so a key missing from Circus Daily's Dutch reads English while
  // DraftKings keeps falling back to French as it did before GAM-729.
  fallbackLng: tenantFallbackLanguage(),
  supportedLngs: [...tenantLanguages()],
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    nl: { translation: nl },
  },
  interpolation: {
    escapeValue: false, // React already escapes
  },
  react: {
    useSuspense: false, // Disable suspense to avoid loading issues
  },
});

// Screen readers and browser translation prompts read this off the document.
document.documentElement.lang = i18n.language;
i18n.on('languageChanged', language => {
  document.documentElement.lang = language;
});

/** The in-app switch: remembered like a URL choice, and applied without a reload. */
export const setLanguage = (language: Language): void => {
  storeLanguage(language);
  void i18n.changeLanguage(language);
};

export default i18n;
